import request from '../tools/request';

export const addVisitInfo = (payload) => request('POST', 'api/visitinfo', payload);
export const getVisitInfoList = (payload) => request('GET', 'api/visitlist', payload, {});